import {
    Component,
    InputSignal,
    input, ChangeDetectionStrategy
} from "@angular/core";

@Component({
    selector: "woa-chewzie-logo",
    templateUrl: "./chewzie-logo.component.html",
    styleUrl: "./chewzie-logo.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChewzieLogoComponent {
    public readonly type: InputSignal<"vertical" | "horizontal"> = input<"vertical" | "horizontal">("horizontal");
    public readonly engage: InputSignal<boolean> = input<boolean>(false);
}
